export const actionTypes = {
  CLEAR_LIST_BRIK: "CLEAR_LIST_BRIK",

  CREATE_BRIK: "CREATE_BRIK",
  CREATE_BRIK_SUCCESS: "CREATE_BRIK_SUCCESS",
  CREATE_BRIK_FAIL: "CREATE_BRIK_FAIL",

  UPDATE_BRIK: "UPDATE_BRIK",
  UPDATE_BRIK_SUCCESS: "UPDATE_BRIK_SUCCESS",
  UPDATE_BRIK_FAIL: "UPDATE_BRIK_FAIL",

  GET_LIST_BRIK: "GET_LIST_BRIK",
  GET_LIST_BRIK_SUCCESS: "GET_LIST_BRIK_SUCCESS",
  GET_LIST_BRIK_FAIL: "GET_LIST_BRIK_FAIL",

  CREATE_SECTION: "CREATE_SECTION",
  CREATE_SECTION_SUCCESS: "CREATE_SECTION_SUCCESS",
  CREATE_SECTION_FAIL: "CREATE_SECTION_FAIL",

  CREATE_LENGTH: "CREATE_LENGTH",
  CREATE_LENGTH_SUCCESS: "CREATE_LENGTH_SUCCESS",
  CREATE_LENGTH_FAIL: "CREATE_LENGTH_FAIL",

  CREATE_DAY: "CREATE_DAY",
  CREATE_DAY_SUCCESS: "CREATE_DAY_SUCCESS",
  CREATE_DAY_FAIL: "CREATE_DAY_FAIL",

  CREATE_SUB_SECTION: "CREATE_SUB_SECTION",
  CREATE_SUB_SECTION_SUCCESS: "CREATE_SUB_SECTION_SUCCESS",
  CREATE_SUB_SECTION_FAIL: "CREATE_SUB_SECTION_FAIL",

  ORDER_SUB_SECTION: "ORDER_SUB_SECTION",
  ORDER_SUB_SECTION_SUCCESS: "ORDER_SUB_SECTION_SUCCESS",
  ORDER_SUB_SECTION_FAIL: "ORDER_SUB_SECTION_FAIL",

  DELETE_SUB_SECTION: "DELETE_SUB_SECTION",
  DELETE_SUB_SECTION_SUCCESS: "DELETE_SUB_SECTION_SUCCESS",
  DELETE_SUB_SECTION_FAIL: "DELETE_SUB_SECTION_FAIL",

  GET_BRIK_DETAIL: "GET_BRIK_DETAIL",
  GET_BRIK_DETAIL_SUCCESS: "GET_BRIK_DETAIL_SUCCESS",
  GET_BRIK_DETAIL_FAIL: "GET_BRIK_DETAIL_FAIL",
  CLEAR_DETAIL_BRIK: "CLEAR_DETAIL_BRIK",

  GET_LIST_SECTION: "GET_LIST_SECTION",
  GET_LIST_SECTION_SUCCESS: "GET_LIST_SECTION_SUCCESS",
  GET_LIST_SECTION_FAIL: "GET_LIST_SECTION_FAIL",

  GET_NAME_SUB_SECTION: "GET_NAME_SUB_SECTION",
  GET_NAME_SUB_SECTION_SUCCESS: "GET_NAME_SUB_SECTION_SUCCESS",
  GET_NAME_SUB_SECTION_FAIL: "GET_NAME_SUB_SECTION_FAIL",

  UPDATE_SECTION: "UPDATE_SECTION",
  UPDATE_SECTION_SUCCESS: "UPDATE_SECTION_SUCCESS",
  UPDATE_SECTION_FAIL: "UPDATE_SECTION_FAIL",

  ORDER_SECTION: "ORDER_SECTION",
  ORDER_SECTION_SUCCESS: "ORDER_SECTION_SUCCESS",
  ORDER_SECTION_FAIL: "ORDER_SECTION_FAIL",

  CREATE_CONTENT: "CREATE_CONTENT",
  CREATE_CONTENT_SUCCESS: "CREATE_CONTENT_SUCCESS",
  CREATE_CONTENT_FAIL: "CREATE_CONTENT_FAIL",

  UPDATE_CONTENT: "UPDATE_CONTENT",
  UPDATE_CONTENT_SUCCESS: "UPDATE_CONTENT_SUCCESS",
  UPDATE_CONTENT_FAIL: "UPDATE_CONTENT_FAIL",

  ORDER_CONTENT: "ORDER_CONTENT",
  ORDER_CONTENT_SUCCESS: "ORDER_CONTENT_SUCCESS",
  ORDER_CONTENT_FAIL: "ORDER_CONTENT_FAIL",

  DELETE_SECTION: "DELETE_SECTION",
  DELETE_SECTION_SUCCESS: "DELETE_SECTION_SUCCESS",
  DELETE_SECTION_FAIL: "DELETE_SECTION_FAIL",

  DELETE_CONTENT: "DELETE_CONTENT",
  DELETE_CONTENT_SUCCESS: "DELETE_CONTENT_SUCCESS",
  DELETE_CONTENT_FAIL: "DELETE_CONTENT_FAIL",

  DUPLICATE_BRIK: "DUPLICATE_BRIK",
  DUPLICATE_BRIK_SUCCESS: "DUPLICATE_BRIK_SUCCESS",
  DUPLICATE_BRIK_FAIL: "DUPLICATE_BRIK_FAIL",

  DUPLICATE_SECTION: "DUPLICATE_SECTION",
  DUPLICATE_SECTION_SUCCESS: "DUPLICATE_SECTION_SUCCESS",
  DUPLICATE_SECTION_FAIL: "DUPLICATE_SECTION_FAIL",

  SHARE_BRIK: "SHARE_BRIK",
  SHARE_BRIK_SUCCESS: "SHARE_BRIK_SUCCESS",
  SHARE_BRIK_FAIL: "SHARE_BRIK_FAIL",

  GET_LIST_SHARE: "GET_LIST_SHARE",
  GET_LIST_SHARE_SUCCESS: "GET_LIST_SHARE_SUCCESS",
  GET_LIST_SHARE_FAIL: "GET_LIST_SHARE_FAIL",

  DELETE_BRIK: "DELETE_BRIK",
  DELETE_BRIK_SUCCESS: "DELETE_BRIK_SUCCESS",
  DELETE_BRIK_FAIL: "DELETE_BRIK_FAIL",

  DELETE_LENGTH: "DELETE_LENGTH",
  DELETE_LENGTH_SUCCESS: "DELETE_LENGTH_SUCCESS",
  DELETE_LENGTH_FAIL: "DELETE_LENGTH_FAIL",

  DELETE_DAY: "DELETE_DAY",
  DELETE_DAY_SUCCESS: "DELETE_DAY_SUCCESS",
  DELETE_DAY_FAIL: "DELETE_DAY_FAIL",

  CHANGE_BRIK_STATUS: "CHANGE_BRIK_STATUS",
  CHANGE_BRIK_STATUS_SUCCESS: "CHANGE_BRIK_STATUS_SUCCESS",
  CHANGE_BRIK_STATUS_FAIL: "CHANGE_BRIK_STATUS_FAIL",

  DUPLICATE_LENGTH: "DUPLICATE_LENGTH",
  DUPLICATE_LENGTH_SUCCESS: "DUPLICATE_LENGTH_SUCCESS",
  DUPLICATE_LENGTH_FAIL: "DUPLICATE_LENGTH_FAIL",

  DUPLICATE_DAY: "DUPLICATE_DAY",
  DUPLICATE_DAY_SUCCESS: "DUPLICATE_DAY_SUCCESS",
  DUPLICATE_DAY_FAIL: "DUPLICATE_DAY_FAIL",

  LIST_SHARED_DATA: "LIST_SHARED_DATA",
  LIST_SHARED_DATA_SUCCESS: "LIST_SHARED_DATA_SUCCESS",
  LIST_SHARED_DATA_FAIL: "LIST_SHARED_DATA_FAIL",

  UNSHARE_BRIK: "UNSHARE_BRIK",
  UNSHARE_BRIK_SUCCESS: "UNSHARE_BRIK_SUCCESS",
  UNSHARE_BRIK_FAIL: "UNSHARE_BRIK_FAIL",

  DELETE_ALL_SUB_SECTION: "DELETE_ALL_SUB_SECTION",
  DELETE_ALL_SUB_SECTION_SUCCESS: "DELETE_ALL_SUB_SECTION_SUCCESS",
  DELETE_ALL_SUB_SECTION_FAIL: "DELETE_ALL_SUB_SECTION_FAIL",

  DELETE_DAY_ALL_SUB_SECTION: "DELETE_DAY_ALL_SUB_SECTION",
  DELETE_DAY_ALL_SUB_SECTION_SUCCESS: "DELETE_DAY_ALL_SUB_SECTION_SUCCESS",
  DELETE_DAY_ALL_SUB_SECTION_FAIL: "DELETE_DAY_ALL_SUB_SECTION_FAIL",

  ORDER_LENGTH: "ORDER_LENGTH",
  ORDER_LENGTH_SUCCESS: "ORDER_LENGTH_SUCCESS",
  ORDER_LENGTH_FAIL: "ORDER_LENGTH_FAIL",

  ORDER_DAYS: "ORDER_DAYS",
  ORDER_DAYS_SUCCESS: "ORDER_DAYS_SUCCESS",
  ORDER_DAYS_FAIL: "ORDER_DAYS_FAIL",

  DRAG_BRIK: "DUPLICATE_BRIK",
  DRAG_BRIK_SUCCESS: "DUPLICATE_BRIK_SUCCESS",
  DRAG_BRIK_FAIL: "DUPLICATE_BRIK_FAIL",
};

export const actions = {
  createBrik: () => ({
    type: actionTypes.CREATE_BRIK,
  }),
  createBrikSuccess: (data: any) => ({
    type: actionTypes.CREATE_BRIK_SUCCESS,
    payload: data,
  }),
  createBrikFail: (err: any) => ({
    type: actionTypes.CREATE_BRIK_FAIL,
    payload: err,
  }),

  updateBrik: () => ({
    type: actionTypes.UPDATE_BRIK,
  }),
  updateBrikSuccess: (data: any) => ({
    type: actionTypes.UPDATE_BRIK_SUCCESS,
    payload: data,
  }),
  updateBrikFail: (err: any) => ({
    type: actionTypes.UPDATE_BRIK_FAIL,
    payload: err,
  }),

  getListBrik: () => ({
    type: actionTypes.GET_LIST_BRIK,
  }),
  getListBrikSuccess: (data: any, type: number) => ({
    type: actionTypes.GET_LIST_BRIK_SUCCESS,
    payload: data,
    typeBrik: type,
  }),
  getListBrikFail: (err: any) => ({
    type: actionTypes.GET_LIST_BRIK_FAIL,
    payload: err,
  }),

  createSection: () => ({
    type: actionTypes.CREATE_SECTION,
  }),
  createSectionSuccess: (data: any) => ({
    type: actionTypes.CREATE_SECTION_SUCCESS,
    payload: data,
  }),
  createSectionFail: (err: any) => ({
    type: actionTypes.CREATE_SECTION_FAIL,
    payload: err,
  }),

  createLength: () => ({
    type: actionTypes.CREATE_LENGTH,
  }),
  createLengthSuccess: (data: any) => ({
    type: actionTypes.CREATE_LENGTH_SUCCESS,
    payload: data,
  }),
  createLengthFail: (err: any) => ({
    type: actionTypes.CREATE_LENGTH_FAIL,
    payload: err,
  }),

  createDay: () => ({
    type: actionTypes.CREATE_DAY,
  }),
  createDaySuccess: (data: any) => ({
    type: actionTypes.CREATE_DAY_SUCCESS,
    payload: data,
  }),
  createDayFail: (err: any) => ({
    type: actionTypes.CREATE_DAY_FAIL,
    payload: err,
  }),

  createSubSection: () => ({
    type: actionTypes.CREATE_SUB_SECTION,
  }),
  createSubSectionSuccess: (data: any) => ({
    type: actionTypes.CREATE_SUB_SECTION_SUCCESS,
    payload: data,
  }),
  createSubSectionFail: (err: any) => ({
    type: actionTypes.CREATE_SUB_SECTION_FAIL,
    payload: err,
  }),

  orderSubSection: () => ({
    type: actionTypes.ORDER_SUB_SECTION,
  }),
  orderSubSectionSuccess: (data: any) => ({
    type: actionTypes.ORDER_SUB_SECTION_SUCCESS,
    payload: data,
  }),
  orderSubSectionFail: (err: any) => ({
    type: actionTypes.ORDER_SUB_SECTION_FAIL,
    payload: err,
  }),

  deleteSubSection: () => ({
    type: actionTypes.DELETE_SUB_SECTION,
  }),
  deleteSubSectionSuccess: (data: any) => ({
    type: actionTypes.DELETE_SUB_SECTION_SUCCESS,
    payload: data,
  }),
  deleteSubSectionFail: (err: any) => ({
    type: actionTypes.DELETE_SUB_SECTION_FAIL,
    payload: err,
  }),

  getBrikDetail: () => ({
    type: actionTypes.GET_BRIK_DETAIL,
  }),
  getBrikDetailSuccess: (data: any) => ({
    type: actionTypes.GET_BRIK_DETAIL_SUCCESS,
    payload: data,
  }),
  getBrikDetailFail: (err: any) => ({
    type: actionTypes.GET_BRIK_DETAIL_FAIL,
    payload: err,
  }),
  clearDetailBrik: () => ({
    type: actionTypes.CLEAR_DETAIL_BRIK,
  }),

  getListSection: () => ({
    type: actionTypes.GET_LIST_SECTION,
  }),
  getListSectionSuccess: (data: any) => ({
    type: actionTypes.GET_LIST_SECTION_SUCCESS,
    payload: data,
  }),
  getListSectionFail: (err: any) => ({
    type: actionTypes.GET_LIST_SECTION_FAIL,
    payload: err,
  }),

  getNameSubSection: () => ({
    type: actionTypes.GET_NAME_SUB_SECTION,
  }),
  getNameSubSectionSuccess: (data: any) => ({
    type: actionTypes.GET_NAME_SUB_SECTION_SUCCESS,
    payload: data,
  }),
  getNameSubSectionFail: (err: any) => ({
    type: actionTypes.GET_NAME_SUB_SECTION_FAIL,
    payload: err,
  }),

  updateSection: () => ({
    type: actionTypes.UPDATE_SECTION,
  }),
  updateSectionSuccess: (data: any) => ({
    type: actionTypes.UPDATE_SECTION_SUCCESS,
    payload: data,
  }),
  updateSectionFail: (err: any) => ({
    type: actionTypes.UPDATE_SECTION_FAIL,
    payload: err,
  }),

  orderSection: () => ({
    type: actionTypes.ORDER_SECTION,
  }),
  orderSectionSuccess: (data: any) => ({
    type: actionTypes.ORDER_SECTION_SUCCESS,
    payload: data,
  }),
  orderSectionFail: (err: any) => ({
    type: actionTypes.ORDER_SECTION_FAIL,
    payload: err,
  }),

  createContent: () => ({
    type: actionTypes.CREATE_CONTENT,
  }),
  createContentSuccess: (data: any) => ({
    type: actionTypes.CREATE_CONTENT_SUCCESS,
    payload: data,
  }),
  createContentFail: (err: any) => ({
    type: actionTypes.CREATE_CONTENT_FAIL,
    payload: err,
  }),

  updateContent: () => ({
    type: actionTypes.UPDATE_CONTENT,
  }),
  updateContentSuccess: (data: any) => ({
    type: actionTypes.UPDATE_CONTENT_SUCCESS,
    payload: data,
  }),
  updateContentFail: (err: any) => ({
    type: actionTypes.UPDATE_CONTENT_FAIL,
    payload: err,
  }),

  orderContent: () => ({
    type: actionTypes.ORDER_CONTENT,
  }),
  orderContentSuccess: (data: any) => ({
    type: actionTypes.ORDER_CONTENT_SUCCESS,
    payload: data,
  }),
  orderContentFail: (err: any) => ({
    type: actionTypes.ORDER_CONTENT_FAIL,
    payload: err,
  }),

  deleteSection: () => ({
    type: actionTypes.DELETE_SECTION,
  }),
  deleteSectionSuccess: (data: any) => ({
    type: actionTypes.DELETE_SECTION_SUCCESS,
    payload: data,
  }),
  deleteSectionFail: (err: any) => ({
    type: actionTypes.DELETE_SECTION_FAIL,
    payload: err,
  }),

  deleteContent: () => ({
    type: actionTypes.DELETE_CONTENT,
  }),
  deleteContentSuccess: (data: any) => ({
    type: actionTypes.DELETE_CONTENT_SUCCESS,
    payload: data,
  }),
  deleteContentFail: (err: any) => ({
    type: actionTypes.DELETE_CONTENT_FAIL,
    payload: err,
  }),

  duplicateBrik: () => ({
    type: actionTypes.DUPLICATE_BRIK,
  }),
  duplicateBrikSuccess: (data: any) => ({
    type: actionTypes.DUPLICATE_BRIK_SUCCESS,
    payload: data,
  }),
  duplicateBrikFail: (err: any) => ({
    type: actionTypes.DUPLICATE_BRIK_FAIL,
    payload: err,
  }),

  duplicateSection: () => ({
    type: actionTypes.DUPLICATE_SECTION,
  }),
  duplicateSectionSuccess: (data: any) => ({
    type: actionTypes.DUPLICATE_SECTION_SUCCESS,
    payload: data,
  }),
  duplicateSectionFail: (err: any) => ({
    type: actionTypes.DUPLICATE_SECTION_FAIL,
    payload: err,
  }),

  shareBrik: () => ({
    type: actionTypes.SHARE_BRIK,
  }),
  shareBrikSuccess: (data: any) => ({
    type: actionTypes.SHARE_BRIK_SUCCESS,
    payload: data,
  }),
  shareBrikFail: (err: any) => ({
    type: actionTypes.SHARE_BRIK_FAIL,
    payload: err,
  }),

  getListShare: () => ({
    type: actionTypes.GET_LIST_SHARE,
  }),
  getListShareSuccess: (data: any) => ({
    type: actionTypes.GET_LIST_SHARE_SUCCESS,
    payload: data,
  }),
  getListShareFail: (err: any) => ({
    type: actionTypes.GET_LIST_SHARE_FAIL,
    payload: err,
  }),

  clearListBrik: () => ({
    type: actionTypes.CLEAR_LIST_BRIK,
  }),
  deleteBrik: () => ({
    type: actionTypes.DELETE_BRIK,
  }),
  deleteBrikSuccess: (data: any) => ({
    type: actionTypes.DELETE_BRIK_SUCCESS,
    payload: data,
  }),
  deleteBrikFail: (err: any) => ({
    type: actionTypes.DELETE_BRIK_FAIL,
    payload: err,
  }),

  deleteLength: () => ({
    type: actionTypes.DELETE_LENGTH,
  }),
  deleteLengthSuccess: (data: any) => ({
    type: actionTypes.DELETE_LENGTH_SUCCESS,
    payload: data,
  }),
  deleteLengthFail: (err: any) => ({
    type: actionTypes.DELETE_LENGTH_FAIL,
    payload: err,
  }),

  deleteDay: () => ({
    type: actionTypes.DELETE_DAY,
  }),
  deleteDaySuccess: (data: any) => ({
    type: actionTypes.DELETE_DAY_SUCCESS,
    payload: data,
  }),
  deleteDayFail: (err: any) => ({
    type: actionTypes.DELETE_DAY_FAIL,
    payload: err,
  }),

  changeBrikStatus: () => ({
    type: actionTypes.CHANGE_BRIK_STATUS,
  }),
  changeBrikStatusSuccess: (data: any) => ({
    type: actionTypes.CHANGE_BRIK_STATUS_SUCCESS,
    payload: data,
  }),
  changeBrikStatusFail: () => ({
    type: actionTypes.CHANGE_BRIK_STATUS_FAIL,
  }),

  duplicateLength: () => ({
    type: actionTypes.DUPLICATE_LENGTH,
  }),
  duplicateLengthSuccess: (data: any) => ({
    type: actionTypes.DUPLICATE_LENGTH_SUCCESS,
    payload: data,
  }),
  duplicateLengthFail: (err: any) => ({
    type: actionTypes.DUPLICATE_LENGTH_FAIL,
    payload: err,
  }),

  duplicateDay: () => ({
    type: actionTypes.DUPLICATE_DAY,
  }),
  duplicateDaySuccess: (data: any) => ({
    type: actionTypes.DUPLICATE_DAY_SUCCESS,
    payload: data,
  }),
  duplicateDayFail: (err: any) => ({
    type: actionTypes.DUPLICATE_DAY_FAIL,
    payload: err,
  }),

  listSharedData: () => ({
    type: actionTypes.LIST_SHARED_DATA,
  }),
  listSharedDataSuccess: (data: any) => ({
    type: actionTypes.LIST_SHARED_DATA_SUCCESS,
    payload: data,
  }),
  listSharedDataFail: (err: any) => ({
    type: actionTypes.LIST_SHARED_DATA_FAIL,
    payload: err,
  }),

  unshareBrik: () => ({
    type: actionTypes.UNSHARE_BRIK,
  }),
  unshareBrikSuccess: (data: any) => ({
    type: actionTypes.UNSHARE_BRIK_SUCCESS,
    payload: data,
  }),
  unshareBrikFail: (err: any) => ({
    type: actionTypes.UNSHARE_BRIK_FAIL,
    payload: err,
  }),

  deleteAllSubSection: () => ({
    type: actionTypes.DELETE_ALL_SUB_SECTION,
  }),
  deleteAllSubSectionSuccess: () => ({
    type: actionTypes.DELETE_ALL_SUB_SECTION_SUCCESS,
  }),
  deleteAllSubSectionFail: (err: any) => ({
    type: actionTypes.DELETE_ALL_SUB_SECTION_FAIL,
    payload: err,
  }),

  deleteDayAllSubSection: () => ({
    type: actionTypes.DELETE_DAY_ALL_SUB_SECTION,
  }),
  deleteDayAllSubSectionSuccess: (data: any) => ({
    type: actionTypes.DELETE_DAY_ALL_SUB_SECTION_SUCCESS,
  }),
  deleteDayAllSubSectionFail: (err: any) => ({
    type: actionTypes.DELETE_DAY_ALL_SUB_SECTION_FAIL,
    payload: err,
  }),

  orderLength: () => ({
    type: actionTypes.ORDER_LENGTH,
  }),
  orderLengthSuccess: (data: any) => ({
    type: actionTypes.ORDER_LENGTH_SUCCESS,
    payload: data,
  }),
  orderLengthFail: (err: any) => ({
    type: actionTypes.ORDER_LENGTH_FAIL,
    payload: err,
  }),

  orderDays: () => ({
    type: actionTypes.ORDER_DAYS,
  }),
  orderDaysSuccess: (data: any) => ({
    type: actionTypes.ORDER_DAYS_SUCCESS,
    payload: data,
  }),
  orderDaysFail: (err: any) => ({
    type: actionTypes.ORDER_DAYS_FAIL,
    payload: err,
  }),
  dragBrik: () => ({
    type: actionTypes.DRAG_BRIK,
  }),
  dragBrikSuccess: (data: any) => ({
    type: actionTypes.DRAG_BRIK_SUCCESS,
    payload: data,
  }),
  dragBrikFail: (err: any) => ({
    type: actionTypes.DRAG_BRIK_FAIL,
    payload: err,
  }),
};
